// extracted by mini-css-extract-plugin
export default {"heading":"IAMeMAlN0HOT8CwvGQNW","volumeContainer":"o342oghkmGJjLYyNgNya","volumeText":"hQlxQnIR4GrW6ocP63hP","volumeSlider":"hzONhkCMmKdgIBhcNwmC"};